import script from "./CreatorChatMemberProfileComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorChatMemberProfileComponent.vue?vue&type=script&setup=true&lang=js"

import "./CreatorChatMemberProfileComponent.vue?vue&type=style&index=0&id=48efa946&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48efa946"]])

export default __exports__